/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, {useEffect, useState} from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Row
} from "shards-react";
import Moment from 'moment';
import JetsoPost from "./JetsoPost";
import Disclaimer from "./Disclaimer"
import PageTitle from "../components/common/PageTitle";

function Items({currentItems}) {
  return (
    <>
      {currentItems && currentItems.map((item, idx) => (
        <Col lg="3" md="6" sm="12" className="mb-4" key={idx}>
          <Card small className="card-post h-100">
              <a href={"/?t=" + encodeURIComponent(item.title) + "&uuid=" + item.uuid}>
              <div
                className="card-post__image"
                style={{backgroundImage: (item.image_self_hosted == true ? `url(https://jetsohub-seo.gitlab.io/image/${item.uuid}.jpg)` : (item.image ? 'url(' + item.image + ')' : `url("https://blogger.googleusercontent.com/img/a/AVvXsEjEDWA7ICCKL7EeKFPGF9uHKT8ygnn9B_bVarniKIxTIcNcC4_4wJdpE-MBvRVPHhw_UCZYOAt8IP0cCsRuoDJvggR7h_TloNfE225BYfSshKkOQYbc5oaITLjqwwFut8UYcEABHtoXDESCvz1-KVjdpGG-DuG0AQYUiwBAqn8lhxHm04Bz_HjDBBT2uA=s0")`))
                    + `, url(${process.env.PUBLIC_URL}/icon.svg)`}}
              />
            </a>
            <CardBody>
              <h5 className="card-title">
                <a className="text-fiord-blue" href={"/?t=" + encodeURIComponent(item.title) + "&uuid=" + item.uuid}>
                  {item.title}
                </a>
              </h5>
            </CardBody>
            <CardFooter>
              <span className="text-muted">{Moment.utc(item.created_date).isSame(new Date(), "day") ?  "今天 " + Moment.utc(item.created_date).utcOffset("+08:00").format('Ah點').replace("AM", "上午").replace("PM", "下午") : Moment.utc(item.created_date).utcOffset("+08:00").format('DD MMM YYYY')}</span>
            </CardFooter>
          </Card>
        </Col>
      ))}
    </>
  )
}

function PaginatedItems({page, itemsPerPage, items}) {
  // We start with an empty list of items.
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    const newOffset = (page - 1) * itemsPerPage % items.length;
    setItemOffset(newOffset);
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage]);


  const buttonList = []
  let templist = []
  const pageNo = parseInt (page);
  const isFirstPage = pageNo == 1;
  const prevPage = pageNo - 1;
  const nextPage = pageNo + 1;
  const totalPage = Math.ceil(items.length / itemsPerPage);
  const isLastPage = pageNo == totalPage;

  buttonList.push(<li key="prev" className={isFirstPage ? "page-item disabled" : "page-item"}><a href={"/?page=" + prevPage} className="page-link" tabIndex="0"
                                                        role="button" aria-disabled="true"
                                                        aria-label="Previous page"
                                                        rel="prev"
                                                        >&lt;</a></li>)

  let count = 0;
  for (let y = pageNo; y > 1 && count <5; y--){
    let temp_pageNo = y - 1;
    if(temp_pageNo <= totalPage) {
      templist.push(<li key={""+temp_pageNo} className={"page-item"}><a role="button"
                                                   className="page-link"
                                                   href={"/?page=" + temp_pageNo}
                                                   tabIndex="0"
                                                   aria-label={"Page " + temp_pageNo + " is your current page"}
                                                   aria-current="page"
                                                   >{temp_pageNo}</a>
      </li>)
      count++;
    }
  }
  for (let z = templist.length - 1; z >= 0; z --){
    buttonList.push(templist[z]);
  }

  for (let i = 0; i<= 5; i++){
    let temp_pageNo = pageNo + i;
    if(temp_pageNo <= totalPage) {
      buttonList.push(<li key={""+temp_pageNo} className={i == 0 ? "page-item active" : "page-item"}>
        <a role="button" className="page-link"
           href={"/?page=" + temp_pageNo}
           tabIndex="0"
           aria-label={"Page " + temp_pageNo + " is your current page"}
           aria-current="page"
           >{temp_pageNo}</a></li>)
    }
  }


  buttonList.push(<li key="next" className={isLastPage ? "page-item disabled" : "page-item"}><a href={"/?page=" + nextPage} className="page-link" tabIndex="0"
                                               role="button" aria-disabled="false"
                                               aria-label="Next page" rel="next" >&gt;</a></li>)

  return (
    <>
      <Items currentItems={currentItems}/>
      <ul className="pagination col-sm-12 pagination-fix ">
        {buttonList}
      </ul>
    </>
  );
}

class JetsoPosts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      JetsoList: []
    };
  }

  async componentDidMount() {
    const dataSet = await fetch("https://jetsohub-seo.gitlab.io/database/master_data_set.json",
      { headers: {'Content-Type': 'application/json'}}
    ).then(res => res.json())
    if(dataSet){
      dataSet.sort((a, b) => {
        const b_published_date = Moment(b.published_date);
        const b_created_date = Moment(b.created_date);
        const a_published_date = Moment(a.published_date);
        const a_created_date = Moment(a.created_date);
        return (b_published_date > a_published_date || b_published_date < a_published_date) ?  b_published_date.toDate().getTime() - a_published_date.toDate().getTime() : b_created_date.toDate().getTime() - a_created_date.toDate().getTime()
      })
      this.logStatistics(dataSet)
      this.setState({JetsoList: dataSet})
    }
  }

  logStatistics(list){
    const items = [
      list.find(item=>item.source == "hkulifestyle"),
      list.find(item=>item.source == "Jetsoclub"),
      list.find(item=>item.source == "jetsotoday"),
      list.find(item=>item.source == "weekendhk"),
      list.find(item=>item.source == "hket"),
      list.find(item=>item.source == "Holidaysmart"),
    ]
    for(const item of items){
      if (item){
        console.log(item.source + ": publish time=>" + item.published_date + " create time=>" + item.created_date)
      }
    }
  }

  render() {
    const { router, params, location, routes } = this.props
    console.log("searching: "+location.search)
    const search_params = new URLSearchParams(location.search);
    const uuid = search_params.get('uuid');
    const page = search_params.get('page') ? (parseInt(search_params.get('page')) <= 0 ? 1 : search_params.get('page')) : 1;
    const goto = search_params.get('goto')

    if(goto == "disclaimer"){
      return <Disclaimer/>
    }

    if(goto == "sitemap"){
      window.location.href = "https://jetsohub-seo.gitlab.io/database/sitemap.xml";
    }

    if(uuid){
      return <JetsoPost uuid={uuid}></JetsoPost>
    }

    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <a href="/"> <span>主頁</span></a>
          &nbsp;
          <span>/</span>
          &nbsp;
          <span>最新文章</span>
        </Row>
        <Row>
          {this.state.JetsoList.length > 0 && <PaginatedItems page={page} itemsPerPage={16} items={this.state.JetsoList}/>}
        </Row>
      </Container>
    );
  }
}

export default JetsoPosts;
